export default function GetYoutubePreview(id){
    return 'https://i.ytimg.com/vi/' + id + '/mqdefault.jpg'
}